import { z } from 'zod';

export const linkApplicationSchema = z.object({
  applicationId: z.string().min(1, 'Choose an application.'),
});

export type ILinkApplicationForm = z.infer<typeof linkApplicationSchema>;
